import { Admin, Resource } from 'react-admin';
import { dataProvider } from './dataProvider';
import AdminGuard from './AdminGuard';
import { adminTheme } from './theme';
import Dashboard from './Dashboard';
import ProductList from './ProductList';
import { ProductEdit, ProductCreate } from './ProductEdit';
import OrderList from './OrderList';
import OrderEdit from './OrderEdit';
import DiscountList from './DiscountList';
import { DiscountEdit, DiscountCreate } from './DiscountEdit';
import UserList from './UserList';
import UserEdit from './UserEdit';

const authProvider = {
    login: () => Promise.resolve(),
    logout: () => { localStorage.removeItem('token'); return Promise.resolve(); },
    checkAuth: () => Promise.resolve(),
    checkError: (error) => {
        if (error.status === 401 || error.status === 403) {
            localStorage.removeItem('token');
            return Promise.reject();
        }
        return Promise.resolve();
    },
    getPermissions: () => Promise.resolve(),
};

const AdminPanel = () => (
    <AdminGuard>
        <Admin basename="/admin" dataProvider={dataProvider} authProvider={authProvider}
            theme={adminTheme} dashboard={Dashboard}>
            <Resource name="products" list={ProductList} edit={ProductEdit} create={ProductCreate}
                recordRepresentation={(record) => `${record.article} — ${record.name}`} />
            <Resource name="orders" list={OrderList} edit={OrderEdit}
                recordRepresentation={(record) => `Заказ #${record.id}`} />
            <Resource name="discounts" list={DiscountList} edit={DiscountEdit} create={DiscountCreate}
                recordRepresentation={(record) => record.name} />
            <Resource name="users" list={UserList} edit={UserEdit}
                recordRepresentation={(record) => record.email} />
        </Admin>
    </AdminGuard>
);

export default AdminPanel;
